let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("89CZ1")).then(() => parcelRequire('vKazA'));